<template>
  <div class="trainingLearningHome">
    <div class="train-info" style="background-color: white">

      <div class="basic swipe-div">
        <van-swipe :autoplay="3000" :show-indicators="false">
          <van-swipe-item v-for="(banner, index) in bannerList" :key="index">
            <img v-lazy="banner.imgUrl" @click="onBanner(banner)"/>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="function-div">
        <van-row style="text-align: center">
          <van-grid :column-num="5" :border="false">
            <van-grid-item v-for="(item, index) in functionList" :key="index" :icon="item.imgUrl" :text="item.name"
                           @click="clickFunction(item.name, item.typeId)"/>
          </van-grid>
        </van-row>
      </div>
    </div>

    <!--    <div class="basic swipe2-div">-->
    <!--      <van-swipe :autoplay="3000" :show-indicators="false">-->
    <!--        <van-swipe-item v-for="(banner, index) in banner1List" :key="index">-->
    <!--          <img v-lazy="banner.imgUrl"/>-->
    <!--        </van-swipe-item>-->
    <!--      </van-swipe>-->
    <!--    </div>-->

    <van-tabs v-model="active" @click="onClick">
      <van-tab title="精选课程"></van-tab>
      <van-tab v-if="isLogin" title="观看记录"></van-tab>
    </van-tabs>


    <div class="list-content" v-if="dataList.length > 0">
      <van-list
        v-model="incomeListLoading"
        :finished="listLoadFinished"
        @load="onLoad"
      >
        <van-row gutter="">
          <template v-for="item in dataList">
            <van-col span="12" class="card-col">
              <div class="content-div">
                <div @click="clickInfo(item.id)">
                  <!--    1    左图右文-->
                  <img class="card-img" :src="item.imgUrl">
                  <div class="card-title">{{ item.name }}</div>
                  <div class="card-bt">
                    <van-col span="9">
                      <div class="card-into">
                        <van-icon name="clock-o"/>
                        {{ item.totalDuration }}<span style="opacity:0; display: inline-block;width: 0">，</span>
                      </div>
                    </van-col>
                    <van-col span="15">
                      <div class="card-into" style="text-align: right;">
                        <van-icon name="eye-o"/>
                        <span style="color: #096CEFFF"> {{ item.studyCount }}</span>人观看过
                      </div>
                    </van-col>
                  </div>
                </div>
              </div>
            </van-col>
          </template>
        </van-row>
      </van-list>
    </div>

    <div v-else class="empty-div" style="width: 100%; text-align: center">
      <template v-if="!incomeListLoading">
        <img class="empty_peixun" src="../../assets/images/train/empty_peixun.png">
        <div>您还未观看课程</div>
      </template>
    </div>

  </div>
</template>

<script>
import { trainBanner, trainArea, trainCourse, trainCourseHist } from '@api/train'
import banner from '../../assets/images/train/train_banner.png'

export default {
  name: 'trainingLearningHome',
  data () {
    return {
      active: 0,
      incomeListLoading: false,
      listLoadFinished: false,
      searchName: '',
      addShop: '',
      bannerList: [],
      banner1List: [{ imgUrl: banner }],
      title: '',
      code: '',
      functionList: [],
      dataList: [],
      pageNum: 0,
      isLogin: false
    }
  },
  created () {
    this.startTime = Date.now()

    this.getTrainBanner()
    this.getTrainArea()
    this.onLoad()
  },
  mounted () {
    // 初始化极光统计
    this.$jiguang.initCountEvent()
    this.token = localStorage.getItem('token')
    if (!this.token || this.token === 'undefined') {
      this.isLogin = false
    } else {
      this.isLogin = true
    }
  },
  methods: {
    onLoad () {
      if (this.active == 0) {
        this.contentList()
      } else {
        this.trainCourseHist()
      }
    },

    onClick (name, title) {
      this.pageNum = 0
      this.dataList = []
      this.incomeListLoading = true
      this.listLoadFinished = false
      if (name == 0) {
        this.contentList()
      } else {
        this.trainCourseHist()
      }
    },

    // 获取观看记录
    trainCourseHist () {
      this.pageNum++
      this.incomeListLoading = true
      trainCourseHist({
        pageNum: this.pageNum,
        pageSize: 10
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.dataList = this.dataList.concat(res.data.data.rows)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取列表内容
    contentList () {
      this.pageNum++
      this.incomeListLoading = true
      trainCourse({
        pageNum: this.pageNum,
        pageSize: 10
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.dataList = this.dataList.concat(res.data.data.rows)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // banner点击
    onBanner (e) {
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_training_browser,学习培训,学习培训,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      if (e.jumpType == 1) {
        // this.enterRouter('trainingLearning', { typeId: e.jumpUrl })
        const data = {
          url: `${process.env.VUE_APP_BASE_HOST}/training?typeId=${e.jumpUrl}`,
          title: e.typeName
        }
        this.$bridge.callHandler('newPage', data, response => {
          console.log('response:', response)
        })
      } else {
        const data = {
          url: e.jumpUrl,
          title: ''
        }
        this.$bridge.callHandler('newPage', data, response => {
          console.log('response:', response)
        })
      }
    },
    // 搜索
    onSearch () {
      // this.enterRouter('trainingLearning', { name: this.searchName })
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/training?name=${this.searchName}`,
        title: '学习培训'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 功能区点击
    clickFunction (name, typeId) {
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_training_browser,学习培训,学习培训,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // this.enterRouter('trainingLearning', { typeId: typeId })
      let data
      if (typeId == 30) {
        data = {
          url: `${process.env.VUE_APP_BASE_HOST}/injury`,
          title: name
        }
      } else {
        data = {
          url: `${process.env.VUE_APP_BASE_HOST}/training?typeId=${typeId}`,
          title: name
        }
      }

      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 获取banner
    getTrainBanner () {
      trainBanner().then(res => {
        if (res.data.code === 200) {
          this.bannerList = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取功能区
    getTrainArea () {
      trainArea().then(res => {
        if (res.data.code === 200) {
          this.functionList = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 商家入驻
    toAdd () {

      // this.enterRouter('trainingAdd')
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/trainingAdd`,
        title: '课程详情'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 查看详情
    clickInfo (id) {
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_training_browser,学习培训,学习培训,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_view_training_info', response => {
        console.log('response:', response)
      })
      // this.enterRouter('trainingInfo', { id: id })
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/trainingInfo?id=${id}`,
        title: '学习培训'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })

    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

//noinspection CssInvalidPseudoSelector
::v-deep .van-icon__image {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

//noinspection CssInvalidPseudoSelector
::v-deep .van-grid-item__text {
  font-size: 13px;
}

//noinspection CssInvalidPseudoSelector
::v-deep .van-grid-item__content {
  padding: 3px 3px 10px 3px;
}

//noinspection CssInvalidPseudoSelector
::v-deep .van-tab {
  font-size: 16px;
}


.trainingLearningHome {
  padding-bottom: 50px;

  .train-info {
    margin-bottom: 6px;
  }

  .function-div {
    padding: 0 10px;
  }

  .swipe-div {
    padding: 10px;
    border-radius: 10px;

    img {
      width: 100%;
      height: 100px;
      border-radius: 8px;
    }
  }

  .swipe2-div {

    padding-top: 5px;

    img {
      width: 100%;
      height: 50px;
      border-radius: 25px;
    }
  }


  .basic {
    border-radius: 0;
    margin-bottom: 0;
  }

  .list-content {
    background-color: #fff;
    padding: 10px 5px;

    .card-col {
      background-color: #fff;
      padding-bottom: 30px
    }

    .content-div {
      background-color: #fff;
      padding: 0 5px;
      line-height: 20px;

      .van-icon {
        vertical-align: -10%;
      }

      .card-title {
        margin: 0 5px;
        font-weight: bold;
        @include add_size($font_size_14);
        display: inline-block;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .card-img {
        height: 100px;
        border-radius: 5px;
        padding-bottom: 5px;
      }

      .card-bt {
        padding-top: 5px;
        margin: 0 5px;
        font-size: 11px;
        color: #999999FF;
      }
    }
  }

  .empty-div {
    padding-top: 40px;
    font-size: 16px;
    color: #999999FF;

    .empty_peixun {
      margin-bottom: 15px;
      height: 150px;
      width: 150px;
      display: inline;
    }
  }


}

</style>
